import s from './style.module.scss';
import { useCallback, useState } from 'react';
// import useStatusBarHeight from '@/hooks/useStatusBarHeight';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const ANSWER_KEYS = {
  DUET_QUESTIONNAIRE_Q1_A1: 'feedback_always',
  DUET_QUESTIONNAIRE_Q1_A2: 'feedback_sometimes',
  DUET_QUESTIONNAIRE_Q1_A3: 'feedback_seldom',
};
export default function Questionnaire(props) {
  const { setStep, setAnswerDic, answerDic } = props;
  const { t } = useTranslation();
  const handleAnswer = useCallback(
    (key) => {
      setAnswer(ANSWER_KEYS[key]);
      setAnswerDic(Object.assign(answerDic, { q1: ANSWER_KEYS[key] }));
      setTimeout(() => setStep(2), 300);
    },
    [answerDic]
  );
  const [answer, setAnswer] = useState();

  return (
    <div className={s.root}>
      <div className={s.title}>{t('DUET_QUESTIONNAIRE_Q1')}</div>
      <div className={s.answerWrapper}>
        {Object.keys(ANSWER_KEYS).map((key) => (
          <div
            onClick={() => handleAnswer(key)}
            key={key}
            className={cx(s.answerItem, { [s.active]: answer === ANSWER_KEYS[key] })}
          >
            {t(key)}
          </div>
        ))}
      </div>
    </div>
  );
}
